import { FormField } from "../../../components/datagrid/CreateFormModal";
import * as yup from "yup";
import dvdlocator from "../../../apis/dvdlocator";
import { SelectOption } from "../../../components/datagrid/types";

async function searchFamilies(query: string): Promise<SelectOption[]> {
  const response = await dvdlocator.get("/families", {
    params: { name: query },
  });
  return response.data.map((item: { id: number; family: string }) => ({
    value: item.id,
    label: item.family,
  }));
}

async function createFamily(name: string): Promise<SelectOption> {
  const response = await dvdlocator.post("/families", { name });
  return {
    value: response.data.id,
    label: name,
  };
}

export const inventoryTableCreateFields: FormField[] = [
  {
    name: "supply.sort",
    label: "Sort",
    type: "number",
  },
  {
    name: "supply.upc",
    label: "UPC",
    type: "text",
    required: true,
    validation: yup
      .string()
      .required("UPC is required")
      .matches(/^\d+$/, "UPC must contain only numbers")
      .min(11, "UPC must be at least 11 digits")
      .max(13, "UPC must be at most 13 digits"),
  },
  {
    name: "supply.html",
    label: "HTML",
    type: "text",
  },
  {
    name: "supply.supply_title",
    label: "Title",
    type: "text",
    required: true,
    prefillOnDuplicate: true,
    prefillTransform: (value) => `DUPLICATE - ${value}`,
    validation: yup
      .string()
      .required("Title is required")
      .min(2, "Title must be at least 2 characters")
      .max(500, "Title must be at most 500 characters"),
  },
  {
    name: "supply.supply_asin",
    label: "ASIN",
    type: "text",
  },
  {
    name: "supply.inventory_id",
    label: "Duplicate inventory ID?",
    type: "checkbox",
    displayContext: "duplicate",
    defaultValue: null,
  },
  {
    name: "inventory.inventory_shelf",
    label: "Shelf",
    type: "text",
    prefillOnDuplicate: true,
    disabledWhen: (formData, isDuplicate) =>
      isDuplicate &&
      formData["supply.inventory_id"] !== null &&
      formData["supply.inventory_id"] !== undefined &&
      formData["supply.inventory_id"] !== "",
  },
  {
    name: "media_types",
    label: "Media Types",
    type: "multiSelect",
    optionsKey: "media_types",
    prefillOnDuplicate: true,
  },
  {
    name: "product_families",
    label: "Families",
    type: "asyncMultiSelect",
    searchFn: searchFamilies,
    createFn: createFamily,
    prefillOnDuplicate: true,
  },
  {
    name: "supply.studio",
    label: "Studio",
    type: "text",
  },
  {
    name: "supply.ebay_itemid",
    label: "Ebay Item ID",
    type: "text",
  },
  {
    name: "supply.walsku",
    label: "Walmart SKU",
    type: "text",
  },
  {
    name: "supply.sup_lin",
    label: "Supplier Link",
    type: "url",
  },
  {
    name: "supply.listed",
    label: "Listed",
    type: "text",
  },
  {
    name: "supply.house",
    label: "House",
    type: "text",
  },
  {
    name: "supply.house_2",
    label: "House 2",
    type: "text",
  },
  {
    name: "supply.supply_notes",
    label: "Supply Notes",
    type: "text",
  },
  {
    name: "supply.threading_notes",
    label: "Threading Notes",
    type: "text",
  },
  {
    name: "supply.inventory_notes",
    label: "Inventory Notes",
    type: "text",
  },
  {
    name: "inventory.prod_list_type",
    label: "Product List Type",
    type: "text",
  },
  {
    name: "supply.alliance",
    label: "Alliance Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.amazon",
    label: "Amazon Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.ccvideo",
    label: "CC Video Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.dealsareus",
    label: "Dealsareus Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.deepdiscount",
    label: "Deep Discount Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.discount_entertainment",
    label: "Discount Entertainment Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.popmarket",
    label: "Ebay BlowIt Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.collectors_choice",
    label: "Collectors Choice Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.inetvideo",
    label: "InetVideo Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.importcds",
    label: "ImportCDs Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.mila",
    label: "Mila Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.gruv",
    label: "Gruv Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.wildcard1",
    label: "Wildcard1 Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.wildcard2",
    label: "Wildcard2 Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.rarewaves",
    label: "Rarewaves Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.target_store",
    label: "Target Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.vei",
    label: "VEI Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.walmart",
    label: "Walmart Price",
    type: "number",
    step: 0.01,
  },
  {
    name: "supply.wowhd",
    label: "WowHD Price",
    type: "number",
    step: 0.01,
  },
];
